// readmore
(function() {

	$('.readmore').readmore({
		collapsedHeight: 200,
		moreLink: '<div class="readmore__button"><a href="#" class="dotted">Развернуть полное описание</a></div>',
		lessLink: '<div class="readmore__button"><a href="#" class="dotted">Свернуть описание</a></div>',
	});

})();



// WEBPACK FOOTER //
// G:/RABOTA/lekar/dev/source/modules/readmore/readmore.js